<template>
        <div class="row justify-content-center">
            <div class="col-lg-5 col-md-7">
                <div class="card bg-secondary shadow border-0">

                    <div class="card-body px-lg-5 py-lg-5">
                        <div class="text-center text-muted mb-4">
                            <h1>Sign In</h1>
                        </div>
                        <form role="form">
                            <base-input class="input-group-alternative mb-3"
                                        placeholder="Email"
                                        addon-left-icon="ni ni-email-83"
                                        v-model="model.email">
                            </base-input>

                            <base-input class="input-group-alternative"
                                        placeholder="Password"
                                        type="password"
                                        addon-left-icon="ni ni-lock-circle-open"
                                        v-model="model.password">
                            </base-input>
                            <div class="text-center" v-if="loaderStatus">
                                <loader></loader>
                            </div>
                            <div class="text-center" v-else>
                                <base-button type="primary" class="my-4" @click="login"> Sign In  </base-button>
                            </div>

                        </form>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-6">
                        <a href="#" class="text-light"><small><router-link to="forgotPassword">Forgot password?</router-link></small></a>
                    </div>

                </div>
            </div>
        </div>
</template>
<script>
    import Loader from "../components/Loader"
  export default {
      name: 'login',
      data() {
          return {
              model: {
                  email: '',
                  password: ''
              }
          }
      },
      components: {
          Loader
      },

      methods: {
          login() {
              // console.log("before:")
              this.$store.dispatch('login_function', this.model)
              // console.log("after:")
          }
      }
  }
</script>
<style>
</style>
